import {
  customReservedInventoryBucketTypeIdFormat,
  locationIdFormat,
  productIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

export const updateReservedInventoryBucket = {
  name: "updateReservedInventoryBucket" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
    kind: z.string().nullable(),
    customTypeId: customReservedInventoryBucketTypeIdFormat.schema
      .nullable()
      .optional(),
    value: z.union([
      z.object({ quantity: z.number().int().min(0) }),
      z.object({ onHandPercentage: z.number().min(0).max(100) }),
    ]),
  }),
  output: z.object({ success: z.boolean() }),
};
